export default "__VITE_ASSET__a0ea3d72__"